import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuthStore } from '../store/authStore';
import { useHydrated } from '../hooks/useHydrated';

/**
 * Shown for any unknown address. The hosting rules return HTTP 404 with the
 * pre-rendered copy of this page (website fix list #3). Visitors who are not
 * signed in get the public pages; signed-in users get their files.
 */
export default function NotFound() {
  const hasSession = useAuthStore((s) => Boolean(s.accessToken));
  const signedIn = useHydrated() && hasSession;
  const link = 'text-sm font-medium text-brand-600 hover:text-brand-700';
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-3 bg-slate-50 px-4 py-24 text-center">
      <Helmet>
        <title>Page not found — MyDocUploads</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <p className="text-5xl font-bold text-brand-600">404</p>
      <h1 className="text-lg font-semibold text-slate-800">Page not found</h1>
      <p className="text-sm text-slate-500">The page you’re looking for doesn’t exist.</p>
      {signedIn ? (
        <Link to="/files" className={`mt-2 ${link}`}>
          Back to my files
        </Link>
      ) : (
        <nav aria-label="Main pages" className="mt-2 flex gap-6">
          <Link to="/" className={link}>
            Home
          </Link>
          <Link to="/pricing" className={link}>
            Pricing
          </Link>
          <Link to="/blog" className={link}>
            Blog
          </Link>
        </nav>
      )}
    </div>
  );
}
